import React from 'react';

export const orderCashPickUpSortasiConfig = [
  {
    path: '/order-cash-pick-up-sortasi',
    component: React.lazy(() => import('./listing/listing')),
  },
  {
    path: '/order-cash-pick-up-sortasi/overview',
    component: React.lazy(() => import('./overview/overview')),
  },
  {
    path: '/order-cash-pick-up-sortasi/confirmationOfSortingResults',
    component: React.lazy(() =>
      import('./confirmationOfSortingResults/confirmationOfSortingResults'),
    ),
  },
  {
    path: '/order-cash-pick-up-sortasi/difference-confirmation',
    component: React.lazy(() =>
      import('./differenceConfirmation/differenceConfirmation'),
    ),
  },
  {
    path: '/order-cash-pick-up-sortasi/view',
    component: React.lazy(() => import('./view/view')),
  },
  {
    path: '/order-cash-pick-up-sortasi/overviewOfSortingResults',
    component: React.lazy(() =>
      import('./overviewOfSortingResults/overviewOfSortingResults'),
    ),
  },
];
